import React from 'react';
import { FolderIcon, FolderPlusIcon, GroupIcon, UngroupIcon, LayersIcon, ListIcon, PlusIcon, CopyIcon, TrashIcon, ExpandIcon, MinimizeIcon } from 'lucide-react';
interface ProjectTreeMenuProps {
  position: {
    x: number;
    y: number;
  };
  onClose: () => void;
  onAction: (action: string) => void;
}
export function ProjectTreeMenu({
  position,
  onClose,
  onAction
}: ProjectTreeMenuProps) {
  // Adjust position to ensure it's visible on screen
  const adjustPosition = () => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const menuWidth = 220;
    const menuHeight = 350;
    let x = position.x;
    let y = position.y;
    if (x + menuWidth > windowWidth) {
      x = windowWidth - menuWidth - 10;
    }
    if (y + menuHeight > windowHeight) {
      y = windowHeight - menuHeight - 10;
    }
    return {
      x,
      y
    };
  };
  const adjustedPosition = adjustPosition();
  const menuItems = [{
    label: 'View Project Tree',
    icon: FolderIcon,
    action: () => {
      onAction('viewProjectTree');
      onClose();
    }
  }, {
    label: 'New Folder',
    icon: FolderPlusIcon,
    action: () => {
      onAction('newFolder');
      onClose();
    }
  }, {
    divider: true
  }, {
    label: 'Group Selected',
    icon: GroupIcon,
    action: () => {
      onAction('groupSelected');
      onClose();
    }
  }, {
    label: 'Ungroup',
    icon: UngroupIcon,
    action: () => {
      onAction('ungroup');
      onClose();
    }
  }, {
    divider: true
  }, {
    label: 'Arrange by Layer',
    icon: LayersIcon,
    action: () => {
      onAction('arrangeByLayer');
      onClose();
    }
  }, {
    label: 'Arrange by Type',
    icon: ListIcon,
    action: () => {
      onAction('arrangeByType');
      onClose();
    }
  }, {
    divider: true
  }, {
    label: 'Add Item',
    icon: PlusIcon,
    action: () => {
      onAction('addItem');
      onClose();
    }
  }, {
    label: 'Duplicate',
    icon: CopyIcon,
    action: () => {
      onAction('duplicate');
      onClose();
    }
  }, {
    label: 'Delete',
    icon: TrashIcon,
    action: () => {
      onAction('delete');
      onClose();
    },
    danger: true
  }, {
    divider: true
  }, {
    label: 'Expand All',
    icon: ExpandIcon,
    action: () => {
      onAction('expandAll');
      onClose();
    }
  }, {
    label: 'Collapse All',
    icon: MinimizeIcon,
    action: () => {
      onAction('collapseAll');
      onClose();
    }
  }];
  return <div className="fixed z-50 bg-white rounded-md shadow-lg border border-gray-200 overflow-hidden w-56 dark:bg-darkbg-secondary dark:border-darkbg-border" style={{
    left: adjustedPosition.x,
    top: adjustedPosition.y
  }} onClick={e => e.stopPropagation()} data-id="element-463">
      {/* Menu items section has been removed as requested */}
    </div>;
}